module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAAAXNSR0IArs4c6QAAAQJJREFUWAntVkEKwjAQTMSD4APUJ4jgWW8+yZMv8AvefYZ9gAdBD+ojevAR6QSyELYVukkhPWxg2WzY7EwmaVLrnPsZY16wks0aELmVZOCxwaGalCZB+EqElCCvipAS5FURUoK8KkJKkM9SBDfiAvaGUbtSYanPIgKwI2wrBe3Kn3YNCsY2Ifdhrd0J5rVSkxXBXuxRbRkqzhEfYOsWQt8BTE56fTGvhvF26Ysb56HI4K9vHQNI+slbgzOxAlAVwO6IfTtLwOPcZCJxkSH6SoSrOBpFci+0D1Y2g335CqVxFhF8JScp4L/80WyNEuFbpIqoIlwBHusZ4YpY/3fEBwvEzwZ+HVLrldJQwgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/imgs/facebook_pie-1@2x.png
// module id = 96
// module chunks = 0